require('components/broker/brokerHireInvestment/brokerHireInvestmentFundHeader/brokerHireInvestmentFundHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { ContentBox } = require('commonsComponents/contentBox');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation.js');
// @ helpers
const { formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { LabelDate } = require('commonsComponents/labelDate');
const DateHelper = require('utilities/dateHelper');
// @ constants
const {
    BROKER_FUNDS_INDEX_VARIATION_DECIMALS,
    BROKER_FUNDS_NET_ASSET_DAY_END_VALUE_DECIMALS,
    BROKER_FUNDS_PARTICIPATIONS_DECIMALS,
    PERCENTAGE_SYMBOL
} = require('constants/index');
const language = getLanguage();
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const {
    NOT_ALLOWED_WEALTH_FUNDS_SELL_SHOW_COST_COUNTRIES
} = require('constants/flagBasedFeatures');

class HireInvestmentHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getParticipacionesLabel(immReimburseInvestment) {
        const { balance, immFlagBasedFeatures, immInvestmentFund } = this.props;
        const reimburseFund = immReimburseInvestment.getIn(['steps', 0, 'reimburseFund']);
        let plainAmountObject;
        if (immFlagBasedFeatures.get(NOT_ALLOWED_WEALTH_FUNDS_SELL_SHOW_COST_COUNTRIES)) {
            const accountBalance = reimburseFund.getIn(['account', 'balance']);
            const accountCurrency = accountBalance.get('currency');
            const fundCurrency = balance.currency;
            if(
                accountCurrency === 'EUR' &&
                fundCurrency !== 'EUR' &&
                !!immInvestmentFund.get('totalValueEur')
            ) {
                plainAmountObject = getPlainAmountObject({
                    amount: immInvestmentFund.getIn(['totalValueEur', 'amount']),
                    currency: 'EUR',
                });
            } else {
                plainAmountObject = getPlainAmountObject({
                    amount: balance.amount,
                    currency: accountCurrency,
                });
            }
        } else {
            plainAmountObject = getPlainAmountObject(balance);
        }
        if (reimburseFund) {
            const participations = reimburseFund.get('fundParticipations');

            return (
                <div className="broker-hire-investment-header__holding-container col-lg-6">
                    <span className="broker-hire-investment-header__holding-container-text">
                        <FormattedText value={"brokerHireInvestment-holdingNumberLabel"} />
                        {formatAmount(participations, undefined, BROKER_FUNDS_PARTICIPATIONS_DECIMALS)}
                        <FormattedText value={"brokerHireInvestment-holdingAmountLabel"} />
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </span>
                </div>
            );
        }
    }

    render() {
        const { modifier, immBrokerProductAdvancedSearch } = this.props;
        const immReimburseInvestment = this.props.immReimburseInvestment.getIn([
            'steps',
            0,
            'reimburseInvestment'
        ]);
        const name = immReimburseInvestment.get('name');
        const isin = immReimburseInvestment.get('isin');
        const rentability = `${formatAmount(Number(immReimburseInvestment.get('rentability')).toFixed(2))} ${PERCENTAGE_SYMBOL}`;
        const holdingValue = immReimburseInvestment.get('holding');
        const variationPoints = immReimburseInvestment.get('variationPoints').toString();
        const variationPercent = immReimburseInvestment.get('variationPercent').toString();
        const netAssetDayEndDate = immReimburseInvestment.getIn(['netAssetValue', 'dayEndDate']);
        const netAssetDayEndValue = {
            amount: immReimburseInvestment.getIn(['netAssetValue', 'amount']),
            currency: immReimburseInvestment.getIn(['netAssetValue', 'currency']),
            decimalsLength: BROKER_FUNDS_NET_ASSET_DAY_END_VALUE_DECIMALS
        };
        const plainAmountObject = getPlainAmountObject(netAssetDayEndValue);

        if (!netAssetDayEndDate || !holdingValue) {
            return null;
        }
        const rentabilityYTDLabel = `${formatText('brokerHireInvestment-performanceYTD')}: `;
        let rentabilityLastYearField;
        if (modifier === 'etfs') {
            const rentabilityLastYearLabel = `${formatText('brokerHireInvestment-lastYearProfitability')} ${DateHelper.getFullYear(DateHelper.todayDate()) - 1}: `;
            const immInstrumentList = immBrokerProductAdvancedSearch.getIn(['results','funds','instrumentsList']);
            let performanceLastYear;
            if (immInstrumentList) {
                const performanceLastYearValue = immInstrumentList.getIn([ 0, 'lastYearReturnValue']);
                performanceLastYear = performanceLastYearValue ?
                formatAmount(Number(performanceLastYearValue).toFixed(2)) + " %" :
                '-';
            }
            else {
                performanceLastYear = '-';
            }
            rentabilityLastYearField = (
                <div  className="broker-hire-investment-header__quote-last-year">
                    {rentabilityLastYearLabel}
                    <span className="broker-hire-investment-header__product-value-last-year">
                        {performanceLastYear}
                    </span>
                </div>
            );
        }


        return (
            <ContentBox id="brokerStocksLikeHeader" customClassName="broker-hire-investment-header broker-hire-investment-header--funds">
                <div className="broker-hire-investment-header__header row">
                    <div className="col-lg-8">
                        <div className="broker-hire-investment-header__company-header">
                            <h2 className="broker-hire-investment-header__company-name">
                                {name}
                            </h2>
                        </div>
                        <span className="broker-hire-investment-header__isin">
                            <FormattedText value="brokerHireInvestment-isin" />: {isin}
                        </span>
                    </div>

                    <div className="col-lg-4">
                        <div className="broker-hire-investment-header__quote-box">
                            <div className="broker-hire-investment-header__quote">
                                {rentabilityYTDLabel}
                                <span className="broker-hire-investment-header__product-value">
                                    {rentability}
                                </span>
                            </div>
                            {rentabilityLastYearField}
                            <div className="broker-hire-investment-header__liquidating-value">
                                <FormattedText value={'brokerHireInvestment-netAssetDayEndDate'} />
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                            </div>

                            <div className="broker-hire-investment-header__index-box">
                                <span className="broker-hire-investment-header__index-value">
                                    <StockExchangeIndexVariation
                                        variationPts={formatAmount(variationPoints, undefined, BROKER_FUNDS_INDEX_VARIATION_DECIMALS)}
                                        variationPerc={formatAmount(variationPercent)}
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="broker-hire-investment-header__wallet-last-price-section row">
                    {this.getParticipacionesLabel(this.props.immReimburseInvestment)}
                    <div className="broker-hire-investment-header__last-price-container col-lg-6">
                        <span className="broker-hire-investment-header__last-price-date">
                            (<LabelDate
                                date={netAssetDayEndDate}
                                language={language}
                                today={LABEL_DATE_TODAY}
                                yesterday={LABEL_DATE_YESTERDAY}
                            />)
                        </span>
                    </div>
                </div>
            </ContentBox>
        );
    }
}

HireInvestmentHeader.propTypes = {
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immReimburseInvestment: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immInvestmentFund: PropTypes.object.isRequired,
    balance: PropTypes.object.isRequired,
    modifier: PropTypes.string
};

module.exports = HireInvestmentHeader;
